<template>
  <div id="app">
    <Header @toggleMenu="menuOpen = !menuOpen" />

    <!-- Burger Menu -->
    <nav v-if="menuOpen" class="menu">
      <router-link to="/" @click="menuOpen = false">🏠 Welcome</router-link>

      <template v-if="isLoggedIn">
        <router-link to="/ProfileView" @click="menuOpen = false">
          <img :src="user.img_url || defaultImg" alt="Profile" class="menu-avatar" />
          Profile
        </router-link>
        <router-link to="/Group" @click="menuOpen = false">👥 Groups</router-link>
        <router-link to="/game" @click="menuOpen = false">🎮 Games</router-link>
        <router-link to="/ranking" @click="menuOpen = false">📊 Ranking</router-link>
        <router-link to="/stats" @click="menuOpen = false">📈 Team Stats</router-link>
        <a href="#" @click.prevent="handleLogout(); menuOpen = false">🚪 Logout</a>
      </template>

      <template v-else>
        <router-link to="/login" @click="menuOpen = false">🔐 Login</router-link>
        <router-link to="/join" @click="menuOpen = false">📝 Join</router-link>
      </template>
    </nav>

    <main class="content">
      <router-view />
    </main>

    <Footer />
  </div>
</template>

<script setup>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { useAuth } from '@/utils/auth'
import axios from 'axios'

const store = useStore()
const router = useRouter()
const defaultImg = store.state.deafult_img
const menuOpen = ref(false)

const { user, isLoggedIn, logout } = useAuth()

function handleLogout() {
  logout()
  router.push('/')
}

onMounted(async () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  let platform = ''
  if (/android/i.test(userAgent)) {
    platform = 'android'
  } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    platform = 'ios'
  }

  const currentRoute = router.currentRoute.value
  const isVerifyWithCode =
    currentRoute.path === '/verify' && !!currentRoute.query.code

  if (platform && !isVerifyWithCode) {
    try {
      const { data } = await axios.post(`${store.getters.apiBaseUrl}/GetVersion`, {
        strUserName: store.getters.strUserName,
        searchKey: 1,
        platform
      })
      const url = data && data[0] && data[0].platform_url
      if (url) {
        window.location.replace(url)
      }
    } catch (e) {
      console.error('Failed to fetch app version', e)
    }
  }
})
</script>


<style>
/* GLOBAL RESET + FONTS */
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  background: linear-gradient(to bottom right, #f5f5f5, #e0eafc);
  background-attachment: fixed;
  color: #333;
  scroll-behavior: smooth;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* MAIN CONTENT */
.content {
  flex: 1;
  padding: 0px 0px 80px;
  box-sizing: border-box;
  margin-top: 70px;
}

/* BURGER MENU */
.menu {
  position: fixed;
  top: 70px;
  right: 20px;
  background-color: #ffffffee;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 12px 18px;
  display: flex;
  flex-direction: column;
  z-index: 1000;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.menu a {
  color: #333;
  text-decoration: none;
  margin: 10px 0;
  font-weight: 500;
  transition: color 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.menu a:hover {
  color: #e67e22;
}

.menu-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 6px;
  vertical-align: middle;
}
</style>
